
import * as yup from 'yup';
import { VALIDATION_MESSAGE } from '../constants/Constants';
import { LanguageConstants } from '../constants/LanguageConstants';



const RequestQuoteValidation: any = yup.object().shape({
  quotes: yup.array().of(
    yup.object().shape({
      // brand_name: yup.string().required(LanguageConstants?.BRAND_NAME_REQUIRD),
      // part_number: yup.string().required(LanguageConstants?.PART_NUMBER_REQUIRED).min(1, LanguageConstants?.PART_NUMBER_MIN).max(50, LanguageConstants?.PART_NUMBER_MAX),
      // quantity: yup.number().required(LanguageConstants?.QUNITYTY_REQUIRED).min(1, LanguageConstants?.QUNTITY_MIN).max(1000000, LanguageConstants?.QUNTITY_MAX).typeError(LanguageConstants?.QUNTITY_NUMBER),
      // description: yup.string().required(LanguageConstants?.DESC_NAME_REQUIRD).max(250, LanguageConstants?.DES_MAX),
       brand_name: yup
    .string()
    .required(LanguageConstants?.BRAND_NAME_REQUIRD)
    .test(
      'no-spaces',
       LanguageConstants?.NO_SPACES_ALLOWED,
      (value) => !/\s/.test(value)
    ),

  part_number: yup
    .string()
    .required(LanguageConstants?.PART_NUMBER_REQUIRED)
    .min(1, LanguageConstants?.PART_NUMBER_MIN)
    .max(50, LanguageConstants?.PART_NUMBER_MAX)
    .test(
      'no-spaces',
       LanguageConstants?.NO_SPACES_ALLOWED,
      (value) => !/\s/.test(value)
    ),

  quantity: yup
    .number()
    .required(LanguageConstants?.QUNITYTY_REQUIRED)
    .min(1, LanguageConstants?.QUNTITY_MIN)
    .max(1000000, LanguageConstants?.QUNTITY_MAX)
    .typeError(LanguageConstants?.QUNTITY_NUMBER),

  description: yup
    .string()
    .required(LanguageConstants?.DESC_NAME_REQUIRD)
    .max(250, LanguageConstants?.DES_MAX)
    .test(
            'no-only-spaces',
            LanguageConstants?.NO_SPACES_ALLOWED ||
            'Spaces are not allowed or cannot be empty',
            (value) => {
              if (!value) return true; // optional case — empty allowed
              return value.trim().length > 0; // disallow only spaces
            }
          ),
      serial_number: yup.string().optional().max(50, LanguageConstants?.SER_MAX),
      model_number: yup.string().optional().max(50, LanguageConstants?.MODAL_MAX),
      media_type: yup.string().optional(),
      file_limit: yup.string().optional(),
      // other_brand_name: yup
      // .string()
      // .when('brand_name', (brand_name:any, schema) => {
      //   if (brand_name[0] == '0') {
      //     return schema.required(LanguageConstants?.OTHER_BRAND_REQUIRED).min(1,LanguageConstants?.OTHER_MIN).max(50, LanguageConstants?.OTHER_MAX);
      //   }
      //   return schema.optional().max(50, LanguageConstants?.OTHER_MAX);
      // }),
      other_brand_name: yup.string().when('brand_name', (brand_name: any, schema) => {
        if (brand_name[0] === '0') {
          return schema
            .required(LanguageConstants?.OTHER_BRAND_REQUIRED)
            .min(1, LanguageConstants?.OTHER_MIN)
            .max(50, LanguageConstants?.OTHER_MAX)
            .test(
              'no-only-spaces',
              LanguageConstants?.NO_SPACES_ALLOWED ||
              'Spaces are not allowed or cannot be empty',
              (value) => (value ? value.trim().length > 0 : false)
            );
        }

        return schema
          .optional()
          .max(50, LanguageConstants?.OTHER_MAX)
          .test(
            'no-only-spaces',
            LanguageConstants?.NO_SPACES_ALLOWED ||
            'Spaces are not allowed or cannot be empty',
            (value) => {
              if (!value) return true; // optional case — empty allowed
              return value.trim().length > 0; // disallow only spaces
            }
          );
      }),

    })
  ),
});




export default RequestQuoteValidation;
